import { render, staticRenderFns } from "./NooDetail.vue?vue&type=template&id=34556de2&"
import script from "./NooDetail.vue?vue&type=script&lang=js&"
export * from "./NooDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports